angular.module('app').factory('RUFTransitionService', function (AppServiceApi, UserDetailsApi, $q) {
    // 'legacy route' : 'RUF route'
    const routeMap = {
        'Admin#/SimulatorDashboard': 'RUF/simulator/dashboard'
    };
    let fac = {
        isRUFRoute: isRUFRoute,
        getRUFRouteFromLegacyRoute: getRUFRouteFromLegacyRoute,
        getHrefFromLegacyRoute: getHrefFromLegacyRoute,
        convertMenuItems: convertMenuItems
    };
    /** Determine whether the given legacyRoute has a RUF equivalent
     *
     */
    function isRUFRoute(legacyRoute) {
        return !!getRUFRouteFromLegacyRoute(legacyRoute);
    }
    /** Get the RUF equivalent route for legacyRoute
     *
     * @returns If there is no RUF equivalent then the legacy route will be returned unmodified
     */
    function getRUFRouteFromLegacyRoute(legacyRoute) {
        return routeMap[legacyRoute];
    }
    /** Get the RUF equivalent route for legacyRoute in a base-href relative form
     *
     * @returns If there is no RUF equivalent then the legacy route will be returned unmodified
     */
    function getHrefFromLegacyRoute(legacyRoute) {
        const rufRoute = getRUFRouteFromLegacyRoute(legacyRoute);
        return legacyRoute;
        // return !!rufRoute ? rufRoute : legacyRoute;
    }
    /** Modify the Route on all MenuItems to their RUF equivalent (if it exists) only if RUF is enabled
     * globally and the ConnectedUser is an admin
     *
     * @param connectedUser Optional. If provided then the API call to fetch it will be avoided
     * @param enableRUF Optional. Should be the value from Configurations. If provided then the API
     * call to fetch it will be avoided
     *
     * @returns If there is no RUF equivalent then the path of the menu item be unmodified
     */
    function convertMenuItems(menuItems, connectedUser, enableRUF) {
        // This allows the caller to optionally provide connectedUser, enableRUF or both so we are
        // not pointlessly fetching them every time if the caller already has them
        return (connectedUser !== undefined ? $q.resolve(connectedUser) : UserDetailsApi.get().then((r) => r.data))
            .then((user) => {
            connectedUser = user;
            return enableRUF !== undefined ? enableRUF : AppServiceApi.settings().then((r) => r.data.EnableRUF);
        })
            .then((enabled) => {
            enableRUF = enabled;
        })
            .then(() => {
            if (connectedUser.IsAdmin && enableRUF) {
                for (const menuItem of menuItems) {
                    menuItem.Route = getHrefFromLegacyRoute(menuItem.Route);
                }
            }
            return menuItems;
        });
    }
    return fac;
});
